import { Get } from "./api";

export const getUser = async () => {
  const result = await Get('/auth/user');

  return result.data;
};
